// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home.jsx')).Home;
    Components.Pip = (await import('./pages/Pip.jsx')).Pip;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import('./pages/Home.jsx'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home }))
          );
    },
    path: '/:context?/',
    channel: null,
  },
  pip: {
    name: 'pip',
    componentName: 'Pip',
    chunk: () => import('./pages/Pip.jsx'),
    get component() {
      return ssr
        ? serverPages.Pip
        : currentRouteName === 'Pip'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pip }))
          );
    },
    path: '/:context?/?p/:slug?/:omsId',
    channel: null,
  },
});
